import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { getList as _getList } from '@/api/setting/modular';
import Edit from './components/edit';
export default {
  name: 'setting-modular',
  data: function data() {
    return {
      currentTableData: [],
      loading: false,
      template: null
    };
  },
  methods: {
    getType: function getType(val) {
      var type = {
        0: 'info',
        1: 'primary',
        2: 'danger'
      };
      if (type[val]) {
        return type[val];
      }
      return val;
    },
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var sortType, _yield$_getList, data, list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              sortType = {
                'Setting_TenantInfo': 0,
                'Setting_TenatStruct': 1,
                'Setting_BusinessType': 2,
                'Setting_UserManger': 3,
                'Setting_AuthorizeManger': 4,
                'Task_Template': 5,
                'Knowledge_Manger': 6
              };
              _context.n = 1;
              return _getList();
            case 1:
              _yield$_getList = _context.v;
              data = _yield$_getList.data;
              list = data.map(function (item) {
                var sort = sortType[item.n99EHName];
                return _objectSpread(_objectSpread({}, item), {}, {
                  soreIndex: sort
                });
              });
              _this.currentTableData = list.sort(function (a, b) {
                return a.soreIndex - b.soreIndex;
              });
              _this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    edit: function edit(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$awaitTo(_this2.$dialog(Edit, {
                dialog: {
                  width: '550px',
                  title: '编辑'
                },
                props: {
                  id: row.n99Id,
                  data: row
                }
              }, function (template) {
                _this2.template = template;
              }));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              _this2.template = null;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _this2.getList();
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.getList();
  },
  filters: {
    type: function type(val) {
      var type = {
        0: '完全不启用控制',
        1: '不启用查询控制',
        2: '启用查询控制以及维护控制'
      };
      if (type[val]) {
        return type[val];
      }
      return val;
    }
  }
};